
import { 
  Card, 
  CardContent,
  CardFooter
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ArrowRight, DollarSign, Check } from "lucide-react";

interface PricingAlertProps {
  alert: {
    id: number;
    supplier: string;
    product: string;
    yourPrice: number;
    competitorPrice: number;
    priceDiff: number;
    competitor: string;
    actionTaken: boolean;
  };
}

export const PricingAlert = ({ alert }: PricingAlertProps) => {
  return (
    <Card className="overflow-hidden">
      <div className="h-2 bg-red-500" />
      <CardContent className="p-4">
        <div className="space-y-4">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="font-semibold text-lg">{alert.product}</h3>
              <p className="text-muted-foreground text-sm">{alert.supplier}</p>
            </div>
            <AlertTriangle className="h-5 w-5 text-amber-500" />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground">Your Price</p>
              <p className="font-semibold text-red-500">${alert.yourPrice.toFixed(2)}</p>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-muted-foreground">{alert.competitor}'s Price</p>
              <p className="font-semibold text-green-600">${alert.competitorPrice.toFixed(2)}</p>
            </div>
          </div>

          <Badge variant="destructive" className="w-full justify-center py-1">
            You're paying {alert.priceDiff}% more than {alert.competitor}
          </Badge>
        </div>
      </CardContent>
      <CardFooter className="bg-muted/30 p-3 flex justify-between">
        {alert.actionTaken ? (
          <Badge variant="outline" className="flex items-center bg-green-100 text-green-800 border-green-300">
            <Check className="h-3 w-3 mr-1" />
            Addressed
          </Badge>
        ) : (
          <Button variant="default" size="sm" className="w-full">
            Contact Supplier <ArrowRight className="h-4 w-4 ml-1" />
          </Button>
        )}
      </CardFooter>
    </Card>
  );
};
